import { Component } from '../helpers/helper';
import { isLtiContext } from '../dialogs/ageGate';

const KEY = 'ga_cookie_consent';

class CState {
	visible = false;
}

export const CookieBanner = Component(() => {
	const s = Vue.reactive(new CState());
	s.visible = !isLtiContext() && !localStorage.getItem(KEY);

	function accept() {
		localStorage.setItem(KEY, 'accepted');
		s.visible = false;
	}
	function decline() {
		localStorage.setItem(KEY, 'declined');
		s.visible = false;
	}

	return () =>
		s.visible ? (
			<div class="cookie-banner" role="dialog" aria-label="Cookie notice">
				<div class="cookie-banner-text">
					We use cookies and browser storage strictly to keep you signed in and remember your preferences. We do <b>not</b> use advertising or third-party tracking cookies. See our <a href="/privacy_policy">Privacy Policy</a> for details.
				</div>
				<div class="cookie-banner-buttons">
					<button class="button secondary" onClick={decline}>Decline</button>
					<button class="button accent" onClick={accept}>Accept</button>
				</div>
			</div>
		) : null;
});
